
import { ActionReducerMap } from '@ngrx/store';
import { sessionReducer } from './session.reducer';
import { AppState } from '../states/app.state';
import { currentUserReducer } from './user.reducer';
import { navigationReducer } from './navigation.reducer';
import { tourManagerReducer } from './tour-manager.reducer';
import { selectedDocTypeReducer } from './selected-doc-type.reducer';



export const reducers: ActionReducerMap<AppState> = {
  session: sessionReducer,
  currentUser: currentUserReducer,
  navigation: navigationReducer,
  tourManager : tourManagerReducer,
  selectedDocType: selectedDocTypeReducer,
};
